import { ReactNode } from 'react';
import MainBlue from './main-blue';

export default function PaymentLayout(props: { children: ReactNode }) {
  const { children } = props;
  return <MainBlue>{children || null}</MainBlue>;
}
